<template>
    <SmartLinkItemComponent :id="model?.system?.id" :component="!model?.system?.workflow" v-if="model">
        <div class="logo-collection">
            <div :class="{'container': nestedContentModel, 'pt-0':paddingModifications['pt-0'], 'pb-0':paddingModifications['pb-0']}">
                <div class="row" v-if="model?.elements?.title?.value">
                    <div class="col-lg" data-aos="fade-in">
                        <SmartLinkStandaloneElement :codename="type.elements.title.codename">
                            <h2 class="title">{{ model?.elements?.title?.value }}</h2>
                        </SmartLinkStandaloneElement>                            
                    </div>
                </div>
                <div class="logo-item-container" data-aos="fade-in">
                    <SmartLinkStandaloneElement :codename="type.elements.logo_items.codename">
                        <div class="row" :class="imageTitle ? 'image-title' : 'image-only'">
                            <LogoItem v-for="item in pageStore.getListAs<LogoItemModel>(model?.elements?.logo_items?.value)" :model="item" :image-title="imageTitle" />
                        </div>                    
                    </SmartLinkStandaloneElement>
                </div>
            </div>
        </div>
    </SmartLinkItemComponent>
</template>

<script lang="ts" setup>
import { inject } from 'vue'
import { contentTypes, type LogoCollectionModel, type LogoItemModel } from '~~/app/models';

const isSplitContentBlock = inject('isSplitContentBlock', false)
const isBasicContentBlock = inject('isBasicContentBlock', false)
const nestedContentModel = computed(() => (isSplitContentBlock || isBasicContentBlock) ? false : true);

const type = contentTypes.logo_collection;
const pageStore = usePageStore();
const props = defineProps<{ model: LogoCollectionModel }>();

const paddingModifications = computed(() => getPaddingModifications(props.model.elements.padding_modifications__padding_modifications));

const imageTitle = computed(() => firstOrDefault(props.model.elements.styling_options.value)?.codename == 'image_and_title');
</script>